import { createPortal } from 'react-dom'
import { Trans } from 'react-i18next'

import { ConditionBooleanOperator, ConditionFeatureFlag } from '@makyoapp/makyo-common'
import { Login16 } from '@makyoapp/makyo-icon/icon'
import { Tip, useTip } from '@makyoapp/makyo-ui'

import { useConditionRepeaterContext } from './ConditionRepeaterContext'
import { useConditionSelectContext } from './ConditionSelectContext'

export function ConditionUserLoggedInDD() {
  const { setOpen, isRhs, index } = useConditionSelectContext()
  const { onChange, value } = useConditionRepeaterContext()
  const key = isRhs ? 'rhs' : 'lhs'

  return isRhs ? null : (
    <button
      className='gap-2 sdd-item cond-user-logged-in'
      onClick={async () => {
        const nextCond = [...value.conditions]
        const isSame = !isRhs ? nextCond[index].lhs.flag === ConditionFeatureFlag.UserLoggedIn : true

        const nextOp = isSame ? nextCond[index].operator : ConditionBooleanOperator.IsFalse

        nextCond[index] = {
          ...nextCond[index],
          [key]: {
            flag: ConditionFeatureFlag.UserLoggedIn,
            value: false,
          },
          operator: nextOp,
        }
        onChange?.({
          isAny: value.isAny,
          conditions: nextCond,
        })
        setOpen(false)
      }}
    >
      <Login16 />
      <div className='txt'>
        <Trans>User Logged-In</Trans>
      </div>
    </button>
  )
}

export function ConditionUserLoggedInStatement() {
  const {
    x,
    y,
    strategy,
    context,
    isOpen: isTipOpen,
    placement,
    arrowRef,
    getFloatingProps,
    refs,
    getReferenceProps,
  } = useTip({
    placement: 'top',
  })

  return (
    <>
      <div className='flex-c min-w-0' ref={refs.setReference} {...getReferenceProps()}>
        <Login16 className='shrink-0' width={14} height={14} />
        <div className='txt'>
          <Trans>User Logged-In</Trans>
        </div>
      </div>

      {isTipOpen &&
        createPortal(
          <Tip
            className='text-m-sm'
            x={x}
            y={y}
            placement={placement}
            strategy={strategy}
            ref={refs.setFloating}
            {...getFloatingProps()}
            context={context}
            arrowRef={arrowRef}
          >
            <div className='flex-c whitespace-nowrap'>
              <Login16 width={14} height={14} />
              <Trans>User Logged-In</Trans>
            </div>
          </Tip>,
          document.body
        )}
    </>
  )
}
